import { Color } from '@/types'
import { Badge as BaseBadge, BadgeProps as BaseBadgeProps } from '../base/badge'

type BadgeColor = BaseBadgeProps['color']

type ClientType = {
  name: string
  color: BadgeColor | Color
}

interface BadgeProps {
  clientType: ClientType
}

export const Badge = ({ clientType }: BadgeProps) => {
  const { color, name } = clientType

  return <BaseBadge color={color?.toLowerCase() as BadgeColor}>{ name }</BaseBadge>
}
